import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "DropDown-root_slWR5"
};
function DropDown({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    role: "menu",
    display: "inline-block",
    paddingY: "xsmall",
    borderRadius: "1x",
    backgroundColor: "white",
    className: clsx(styles.root, className),
    ...extraProps
  });
}
export default DropDown;